var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.counter
          ? _c("div", { staticClass: "mask" }, [
              _c("div", { staticClass: "loader" }, [
                _vm._v("\n        " + _vm._s(_vm.message) + "\n      "),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }